import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useOutletContext, useParams, useSearchParams } from "react-router-dom";
import DataTable, { DATA_TABLE_TYPES } from "../../components/Table/DataTable";
import UsersService from "../../services/users.service";
import { uid } from "../../helper";
import { useModal } from "../../hooks/useModal";
import { UserView } from "./UserView";
import TableAction from "../../components/Table/TableAction";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { UserStatus } from "./UserStatus";
import { UserMobile } from "./UserMobile";
import { DATA_TABLE_FILTER } from "../../components/Table/FilterPopup";
import { SubscriptionDate } from "../../components/General/SubscriptionDate";
import { ROUTES } from "../../services/constants";

const Users = () => {
    const {t} = useTranslation();
    const {setPageTitle} = useOutletContext();
    const {openModal} = useModal();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    
    let defaultFilterConfig = {};
    if(params.has('subscription'))
        defaultFilterConfig.subscription = params.get('subscription');
    if(params.has('online'))
        defaultFilterConfig.online = params.get('online');
    
    const columns = [
        { 
            key: "id",
            label: "#",
            sort: true
        },
        { 
            key: "uid", 
            label: t("Account Number"), 
            render: (row) => uid(row.uid), 
            filter: DATA_TABLE_FILTER.INPUT,
            to: (row) => (`${ROUTES.ACCOUNT_DASHBOARD.replace(':uid', row.uid)}`)
        },
        { 
            key: "full_name", 
            label: t("Fullname"), 
            render: (row) => (row.first_name+" "+row.last_name),
            sort: true,
            filter: DATA_TABLE_FILTER.INPUT
        },
        { 
            key: "email", 
            label: t("E-Mail"),
            filter: DATA_TABLE_FILTER.INPUT
        },
        { 
            key: "msisdn", 
            label: t("Phone"), 
            render: (row) => <UserMobile row={row} />,
            filter: DATA_TABLE_FILTER.INPUT
        },
        { 
            key: "subscription", 
            label: t("Subscription"), 
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            render: (row) => <SubscriptionDate user={row} />,
            options: [
                { key: "active", value: t("Active subscribers") }, 
                { key: "expired", value: t("Expired subscribers") }, 
                { key: "no", value: t("Non-subscribers") }
            ]
        },
        { 
            key: "created_at", 
            label: t("Member Since"), 
            type: DATA_TABLE_TYPES.DATE_TIME,
            sort: true,
            filter: DATA_TABLE_FILTER.DATE_RANGE
        },
        { 
            key: "disabled_at", 
            label: t("Status"), 
            render: (row) => <UserStatus row={row}/>,
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: [{ key: "active", value: t("Active") }, { key: "disable", value: t("Disable") }]
        }

    ]
    useEffect(() => { 
        setPageTitle(t("All Users List A/Z"));
    }, [setPageTitle]);
    return (
        <>
            <DataTable 
                columns={columns} 
                fetcher={UsersService.list}
                searchPlaceholder={t("Search by Account Number or E-Mail or Fullname...")}
                defaultFilterConfig={defaultFilterConfig}
                customFilters={[{ 
                    key: "online", 
                    label: t("Online Status"),
                    filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
                    options: [
                        { key: "true", value: t("Online") }, 
                        { key: "false", value: t("Offline") }
                    ]
                }]}
                actions={(data, context) => {
                    return (
                        <>
                            <TableAction onClick={(e) => openModal(<UserView context={context} data={data} />)}>{t("View")}</TableAction>
                        </>
                    )
                }}
            />
        </>
    )
}
export default Users;